import event from './event'
import QueryUtils from '../libs/query'
import Objects from '../libs/objects'
import ServiceAccounts from '../serviceAccounts'

const checkAction = async ({ action, filter }) => {
  const { id, type, serviceAccountId } = action
  const prefix = `Action: ${filter}:${id} `
  const required = Objects.checkRequired(action, ['id', 'type', 'action', 'serviceAccountId'], prefix)
  let status = true
  let messages = []

  if (!required.status) {
    status = false
    messages = messages.concat(required.messages)
  }

  const checkServiceAccount = await ServiceAccounts.isServiceAccountOfType({ type, id: serviceAccountId })
  if (!checkServiceAccount) {
    status = false
    messages.push(`Service Account ${serviceAccountId} is not of action type ${type}`)
  }

  return { status, action: id, messages }
}

const checkConditionFilter = ({ id, condition }) => {
  if (!condition) return { status: true, messages: [] }
  return { filter: id, ...QueryUtils.checkQuery(condition) }
}

const checkFilters = async (filter) => {
  const { id, condition, actions = [] } = filter
  const checkCondition = checkConditionFilter({ id, condition })
  let { status } = checkCondition

  const actionErrors = await Promise.all(actions.map(action => checkAction({ filter: id, action })))
    .then(actionVerify => actionVerify.filter(({ status: verifyStatus }) => !verifyStatus))

  if (actionErrors.length > 0) status = false

  let errors = []
  if (!checkCondition.status) errors.push(checkCondition)
  if (actionErrors.length > 0) errors = errors.concat(actionErrors)

  const requiredFields = Objects.checkRequired(filter, ['id'], 'Filters:')
  if (!requiredFields.status) {
    status = false
    errors.push({ filter: id, ...requiredFields })
  }
  return { id, status, errors }
}

const checkModel = (id, model) => ({ id, ...QueryUtils.checkPropertyTypes(model) })

export const checkEvent = async (id) => {
  const eventPayload = event.loadEventData(id)
  const { model = {}, filters = [] } = eventPayload

  const requiredVerify = Objects.checkRequired(eventPayload, ['id', 'model', 'filters'])
  const modelVerify = checkModel(id, model)
  let { status } = requiredVerify

  const { status: modelStatus } = modelVerify
  if (!modelStatus) status = modelStatus

  const filterErrors = (filters && await Promise.all(filters.map(filter => checkFilters(filter)))
    .then(verify => verify.filter(({ status: verifyStatus }) => !verifyStatus))) || []

  let errors = []
  if (!requiredVerify.status) errors = errors.concat(requiredVerify)
  if (!modelVerify.status) errors = errors.concat(modelVerify)
  if (filterErrors.length > 0) {
    filterErrors.forEach((error) => { errors = errors.concat(error.errors) })
    status = false
  }

  return { id, status, errors }
}

export const checkAll = async () => {
  const events = event.getEventsInFolder()
  const eventsWithErrors = await Promise.all(events.map(item => checkEvent(item)))
    .then(verify => verify.filter(({ status: verifyStatus }) => !verifyStatus))
  console.log(eventsWithErrors[0].errors[0])
  return { status: eventsWithErrors.length === 0, errors: eventsWithErrors }
}
